export default __webpack_public_path__ + "static/media/f0d373c302b5c689e4445a1c3a9691a3.f0d373c3.svg";